/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import Label from './Label';
import styles from '../../../styles/partials/page-heading.scss';

import blueBackground from '../../../img/section-header-background-blue.png';
import yellowBackground from '../../../img/section-header-background-yellow.png';

const propTypes = {
    title: PropTypes.node.isRequired,
    isYellow: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    isYellow: false,
    className: null,
};

const PageHeading = ({ title, isYellow, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.background,
                    {
                        [styles.yellow]: isYellow === true,
                    },
                ])}
                style={{
                    backgroundImage: `url(${isYellow ? yellowBackground : blueBackground})`,
                }}
            >
                <div className={styles.text}>
                    <div className={styles.title}>
                        <Label>{title}</Label>
                    </div>
                </div>
            </div>
        </div>
    );
};

PageHeading.propTypes = propTypes;
PageHeading.defaultProps = defaultProps;

export default PageHeading;
